import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import GridFilterPanel from '../../commons/filters/GridFilterPanel.jsx';
import { buildPeriodoOptions } from '../../commons/filters/periodos.js';
import { cargarUbicaciones } from './inventarioUbicaciones.js';
import {
	INVENTARIO_SOLICITUDES_FILTROS_STORAGE_KEY,
	buildInventarioSolicitudesFilterFields,
	getInventarioSolicitudesFilterDefaults,
} from './inventarioSolicitudesFilterFields.js';

/**
 * VEC-3317 — filtros de la grilla de Solicitudes de Stock.
 *
 * Alimenta a <GridFilterPanel /> con las opciones de sus desplegables; el estado, la persistencia y
 * la serialización son del panel compartido. Molde: `InventarioMovimientosGridFiltros.jsx`.
 *
 * ⚠️ No se toca `commons/filters/GridFilterPanel.jsx`: es compartido con Facturas, Tickets, Móviles
 * y las otras dos pantallas de Inventario. Todo lo que esta pantalla necesita se resuelve declarando
 * campos.
 *
 * La PESTAÑA (Pendientes / Finalizadas) no es un campo de acá: la maneja la grilla. Es la pantalla
 * en la que estás, no un filtro que se acumula con los demás — y si viviera en el panel, "Restaurar
 * filtros" te cambiaría de pestaña.
 */

const OPTIONS_INIT = { periodo: [], ubicacionId: [] };

const InventarioSolicitudesGridFiltros = (props) => {
	const intl = useIntl();

	const [options, setOptions] = useState(OPTIONS_INIT);
	const [optionsLoading, setOptionsLoading] = useState(true);

	const fields = buildInventarioSolicitudesFilterFields();

	// Las opciones de período no salen de un endpoint: son la lista compartida de atajos
	// (`commons/filters/periodos.js`). Se arman acá y no se piden.
	const opcionesFijas = () => ({ periodo: buildPeriodoOptions(intl) });

	useEffect(() => {
		setOptionsLoading(true);
		// El catálogo COMPLETO de ubicaciones —almacenes del Pañol y bases—, no solo los almacenes.
		// El stock vive en los dos desde VEC-3316, y ofrecer la mitad hacía imposible filtrar por el
		// depósito donde realmente está la solicitud. Es el mismo helper que usan la grilla de stock
		// y el formulario de ingreso, así que la lista y su serialización son una sola.
		cargarUbicaciones()
			.then((ubicaciones) => setOptions(Object.assign({}, opcionesFijas(), { ubicacionId: ubicaciones })))
			.catch(() => setOptions(Object.assign({}, OPTIONS_INIT, opcionesFijas())))
			.finally(() => setOptionsLoading(false));
	}, []);

	return (
		<GridFilterPanel
			open={props.open}
			fields={fields}
			options={options}
			defaults={getInventarioSolicitudesFilterDefaults()}
			storageKey={INVENTARIO_SOLICITUDES_FILTROS_STORAGE_KEY}
			loading={props.loading || optionsLoading}
			// Grilla de React/MUI: trae los datos ella misma a partir del query. Sin esto, los filtros
			// persistidos se ven en los controles pero no están aplicados.
			applyOnMount={true}
			resetSignal={props.resetSignal}
			onResetSignalHandled={props.onResetSignalHandled}
			onApply={props.onApply}
		/>
	);
};

export default InventarioSolicitudesGridFiltros;
